module.exports = __webpack_public_path__ + "static/img/cwy41.83ae264.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cwy41.png
// module id = 7uUy
// module chunks = 73